import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import firebase from "firebase";

// localStorage.clear();

const firebaseConfig = {
  apiKey: "AIzaSyC4i6Gx2Kw17R1Q7FGzHLxl0a153pXn3MU",
  authDomain: "birthedmn.firebaseapp.com",
  databaseURL: "https://birthedmn.firebaseio.com",
  projectId: "birthedmn",
  storageBucket: "birthedmn.appspot.com",
  messagingSenderId: "1072948116121",
  appId: "1:1072948116121:web:7d4f0b8a24e3c2af439608"
};

firebase.initializeApp(firebaseConfig);

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
